export default __webpack_public_path__ + "static/media/alicia.6735591a.png";